import { render, staticRenderFns } from "./ColoredAvatar.vue?vue&type=template&id=7153cd76&scoped=true"
import script from "./ColoredAvatar.vue?vue&type=script&lang=ts"
export * from "./ColoredAvatar.vue?vue&type=script&lang=ts"
import style0 from "./ColoredAvatar.vue?vue&type=style&index=0&id=7153cd76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7153cd76",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAvatar,VProgressCircular,VTooltip})
